import { render, staticRenderFns } from "./WasteDetailsInventory.vue?vue&type=template&id=4d45085d&"
import script from "./WasteDetailsInventory.vue?vue&type=script&lang=js&"
export * from "./WasteDetailsInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports